import type { SessionAvailability } from "@/lib/sessionAvailability";

/**
 * "Add task" / paste entry point. A signed-out session must not build a draft:
 * that used to throw "No current user found" from the click handler.
 */
export function runAddTaskClick<T>(args: {
    availability: SessionAvailability;
    redirectToLogin: () => void;
    build: () => T | null;
}): T | null {
    if (args.availability === "signed-out") {
        args.redirectToLogin();
        return null;
    }
    return args.build();
}
